
import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';


interface DataTableColumn<T> {
  label: string;
  render: (row: T) => React.ReactNode;
}


interface DataTableProps<T> {
  rows: T[];
  columns: DataTableColumn<T>[];
  title?: string;
  getRowKey?: (row: T, idx: number) => string | number;
}


function DataTable<T>({ rows, columns, title, getRowKey }: DataTableProps<T>) {
  if (!rows.length) return null;

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      {
        title && (
          <Typography sx={{ p: 2, pb: 0, fontWeight: 'bold', color: '#333' }}>
            {title}
          </Typography>
        )
      }
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: '#f8f8f8' }}>
            {columns.map((col, idx) => (
              <TableCell key={idx}>{col.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <TableRow key={getRowKey ? getRowKey(row, idx) : idx}>
              {columns.map((col, cidx) => (
                <TableCell key={cidx}>{col.render(row)}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default DataTable;
